
import Vue from "vue";
import { FunnelsServices } from "@/services";
export default Vue.extend({
  data() {
    return {
      domain: "",
      errMsg: "",
      state: ''
    };
  },
  methods: {
    async generateCertificate() {
      try {
        this.errMsg = ''
        this.state = 'Generating certificate...'
        if (!this.domain) return;
        const { data } = await FunnelsServices.regenerateLevel0Cert({ domain: this.domain });

        if(data.managed){
          this.state = data.managed.state
        }else if(data.certMap){
          this.state = 'Provisioning certificate... It may take up to 10-55 minutes.'
        }
      } catch (error: any) {
        this.errMsg = error.response.data.message;
        this.state = 'Something went wrong'
        console.error(error);
      }
    }
  }
});
